/**
 * @generated SignedSource<<18025f3ce35874619399227cca43e5de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ECommerceUrlValidity = "NOT_VALID" | "VALID";
export type connectShopDialogMutation$variables = {
  urlStore: string;
};
export type connectShopDialogMutation$data = {
  readonly checkUrlStore: {
    readonly installUrl: string | null;
    readonly validity: ECommerceUrlValidity;
  };
};
export type connectShopDialogMutation = {
  response: connectShopDialogMutation$data;
  variables: connectShopDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "urlStore"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "urlStore",
        "variableName": "urlStore"
      }
    ],
    "concreteType": "CheckUrlStore",
    "kind": "LinkedField",
    "name": "checkUrlStore",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "validity",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "installUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "connectShopDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "connectShopDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2a2b9dac0cca5f3dbb8709b9c1416c48",
    "id": null,
    "metadata": {},
    "name": "connectShopDialogMutation",
    "operationKind": "mutation",
    "text": "mutation connectShopDialogMutation(\n  $urlStore: String!\n) {\n  checkUrlStore(urlStore: $urlStore) {\n    validity\n    installUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "3df09b4bed90877d1759cd2804efb871";

export default node;
